import React from "react";
import "../Styles/styles.css";


const CLACT = () => (
    <div className="container">
        <div className="section-title">
            <h2 >CLACT</h2>
        </div>
        <div className="text-center">
            <p className="text-muted">Cloud Accounting</p>
        </div>
        <div>
            <p>
                CLACT addresses all standard accounting requirements like, processing of all financial transactions,
                maintenance of general and sub ledgers and facilitate compilation of balance sheets, P & L accounts
                and statutory returns.
            </p>
            <p>
                All the security features are built in including audit trail.
            </p>
            <div>
                <p>System provides following unique facilities:</p>
                <ul>
                    <li>Facility to mimic manual filing system including all financial transactions. These can be viewed over the cloud.</li>
                    <li>Multi-tenancy - Group companies can have the same software and set up the system for all their firms.</li>
                    <li>Access can be given to auditors to verify the accounts without visiting the office for audit purposes.</li>
                    <li>Possible to maintain centralized accounting systems covering multiple offices.</li>
                    <li>The company is committed to periodic enhancements based on feedback from the field.</li>
                </ul>

            </div>
            <div>
                <h5>Product is available in two versions</h5>
                <p>CLACT Standard</p>
                <p>CLACT Enterprise - customizable</p>
                <a href="https://www.mmcspl.com/docs/Cloud%20Accounting%20Brochure.pdf" className="btn btn-primary" download>
                    Click here to download CLACT Brochure
                </a>
            </div>
        </div>
    </div>
);

export default CLACT;
